import { createApp, type App } from 'vue';
import AntDesignVue from 'ant-design-vue';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ConfirmDialog from 'primevue/confirmdialog';
import Toast from 'primevue/toast';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import 'primeicons/primeicons.css';
import ManagerNotifications from './index.vue';

const MOUNT_ID = 'lkManagerNotificationsApp';

let managerNotificationsApp: App<Element> | null = null;
let currentMountEl: HTMLElement | null = null;

export function initManagerNotifications(root?: ParentNode): void {
  const mountEl = root
    ? (root.querySelector<HTMLElement>(`#${MOUNT_ID}`) ?? document.getElementById(MOUNT_ID))
    : document.getElementById(MOUNT_ID);

  if (!mountEl) {
    return;
  }

  if (managerNotificationsApp && currentMountEl) {
    managerNotificationsApp.unmount();
    currentMountEl.innerHTML = '';
  }

  const app = createApp(ManagerNotifications);

  app.use(AntDesignVue);
  app.use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        darkModeSelector: false,
      },
    },
  });
  app.component('Button', Button);
  app.component('DataTable', DataTable);
  app.component('Column', Column);
  app.component('ConfirmDialog', ConfirmDialog);
  app.component('Toast', Toast);
  app.use(ToastService);
  app.use(ConfirmationService);

  app.mount(mountEl);

  managerNotificationsApp = app;
  currentMountEl = mountEl;
}
